/**
 * This file is auto generated via npm run generate.resolved-outline
 */
export default {
  destBasePath: 'dist',
  components: { bundle: ['sic-base', 'outline', 'utility'] },
  assets: { dir: ['src/assets'], sync: ['dist', 'src/.storybook/static/dist'] },
  screens: {
    xs: '480px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1380px',
    xxl: '1920px',
    xxxl: '2180px',
  },
  css: {
    global: [
      { src: 'outline.fonts.css', dest: 'dist/outline.fonts.css' },
      { src: 'outline.theme.css', dest: 'dist/outline.theme.css' },
      { src: 'src/shared.css', dest: 'dist/shared.css' },
      { src: 'src/tailwind.css', dest: 'dist/tailwind.css' },
      { src: 'src/.storybook/storybook.css', dest: 'dist/storybook.css' },
      { src: 'src/ckeditor5.css', dest: 'dist/ckeditor5.css' },
    ],
    fouc: { enabled: true, dest: 'dist/fouc.css' },
  },
  js: { output: { lazy: false, full: true, data: false } },
  color: { sets: ['outline', 'primary', 'secondary', 'tertiary', 'neutral'] },
  icons: {
    libraries: {
      bootstrap: false,
      boxicons: false,
      fontawesome: true,
      heroicons: false,
      iconoir: false,
      ionicons: false,
      jam: false,
      lucide: false,
      material: false,
      remix: false,
      unicons: false,
    },
    defaults: { library: 'bootstrap', size: '16px', icon: 'chevron-right' },
  },
  youtube: { defaultVideo: 'xiqgG8HUZXE' },
  vimeo: { defaultVideo: '432639001' },
  excludedStories: [
    'outline-accordion',
    'outline-accordion-panel',
    'outline-breadcrumb',
    'outline-button',
    'outline-card',
    'outline-container',
    'outline-dropdown',
    'outline-heading',
    'outline-icon',
    'outline-image',
    'outline-image-slider',
    'outline-link',
    'outline-list',
    'outline-video-vimeo',
    'outline-video-youtube',
    'baseline-styled-text',
  ],
  splide: { keyboard: false, arrows: true },
};
